"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ClaytonLogoStyles = _styledComponents["default"].svg.withConfig({
  componentId: "sc-2gayzq-0"
})([".letter,.copyright{fill:", ";}.roof{fill:", ";}"], function (props) {
  return props.letterColor;
}, function (props) {
  return props.rooftopColor;
});

var _default = ClaytonLogoStyles;
exports["default"] = _default;